<div class="w-100 text-center header-section">
  <div *ngIf="hasFiltersOrActions" class="d-flex flex-row justify-content-between align-items-center mb-6">
    <div class="filter-tabs" [class.fake-hide]="!filterTypes.length">
      <ul class="nav nav-stretch nav-pills nav-pills-custom d-flex">
        <li class="nav-item p-0" *ngFor="let filter of filterTypes; let i = index">
          <a
            [class.active]="filter.index === filterObject.index"
            class="nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1"
            (click)="filterTypeChange(i)"
            href="javascript:void(0)"
          >{{ filter.displayName }}</a>
        </li>
      </ul>
    </div>
    <div *ngIf="hasActionsArea" class="d-flex flex-row justify-content-between align-items-center">
      <ng-content select="[actionsArea]"></ng-content>
    </div>
  </div>
  
  <div class="d-flex flex-wrap justify-content-between gap-5">
    <form class="d-flex align-items-center position-relative my-1 flex-grow-1" autocomplete="off">
      <input type="hidden"/>

      <!-- <svg-icon
        src="assets/svg/system/search.svg?rand=1.2"
        class="svg-icon svg-icon-2 svg-icon-lg-1 text-gray-500 position-absolute top-50 svg-muted ms-5 translate-middle-y d-flex"
      ></svg-icon> -->
      <app-global-font-icon [style]="'outline'" [ICON]="'magnifier'" [customClasses]="'fs-3'" class="position-absolute ms-4"></app-global-font-icon>
      

      <input
        type="text"
        class="form-control form-control-solid ps-15"
        [(ngModel)]="searchWord"
        (ngModelChange)="searchWordChange()"
        [ngModelOptions]="{standalone: true}"
        [placeholder]="searchBarPlaceHolder"
      />

      <span class="position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-5" data-kt-search-element="spinner">
        <span class="spinner-border h-15px w-15px align-middle text-gray-400"></span>
      </span>

      <span class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 me-5 d-none" data-kt-search-element="clear">
        <span class="svg-icon">
          <!-- Clear icon here -->
        </span>
      </span>
    </form>

    <div *ngIf="sortTypes?.length" class="dropdown" ngbDropdown>
      <button class="btn btn-light btn-active-light-primary dropdown-toggle gap-2 h-100" type="button" id="dropdownMenuButton" ngbDropdownToggle>
        <strong>Sorted By</strong>
        {{ sortObject.displayName || "Default" }}
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" ngbDropdownMenu>
        <a
          *ngFor="let sort of sortTypes; let i = index"
          [class.active]="sort.index === sortObject.index"
          href="javascript:void(0)"
          (click)="sortTypeChange(i)"
          class="dropdown-item"
        >{{ sort.displayName }}</a>
      </div>
    </div>
  </div>

  <div *ngIf="paginationLabel && paginationTotal && paginationView" class="sort-list mb-6 d-flex justify-content-between">
    <div class="numberShowing">
      <div class="form-text text-start text-muted">
        Showing  {{ paginationView }} of {{ paginationTotal }} {{ paginationLabel }}
      </div>
    </div>
  </div>
</div>
